import type { CuttingStrategy } from './CuttingStrategy';
import { FirstFitStrategy } from './FirstFitStrategy';
import { MaxRectsStrategy } from './MaxRectsStrategy';
import { OrientationCompareStrategy } from './OrientationCompareStrategy';
import { LandscapeFirstDebugStrategy } from './LandscapeFirstDebugStrategy';
import { DebugStrategy } from './DebugStrategy';
import { MaterialDivisionStrategy } from './MaterialDivisionStrategy';
import { OrientationAnalysisStrategy } from './OrientationAnalysisStrategy';
import { RowBasedOrientationStrategy } from './RowBasedOrientationStrategy';
import { CompareDebugStrategy } from './CompareDebugStrategy';

export class StrategyFactory {
    private static strategies = new Map<string, CuttingStrategy>([
        ['first-fit', new FirstFitStrategy()],
        ['max-rects', new MaxRectsStrategy()],
        ['orientation-compare', new OrientationCompareStrategy()],
        ['landscape-first-debug', new LandscapeFirstDebugStrategy(false)],
        ['portrait-first-debug', new LandscapeFirstDebugStrategy(true)],
        ['debug', new DebugStrategy()],
        ['material-division', new MaterialDivisionStrategy()],
        ['orientation-analysis', new OrientationAnalysisStrategy()],
        ['row-based-orientation', new RowBasedOrientationStrategy()],
        ['debug-strategy-compare', new CompareDebugStrategy()],
    ]);

    static getStrategy(name: string): CuttingStrategy {
        const strategy = this.strategies.get(name);
        if (!strategy) {
            throw new Error(`Strategy ${name} not found`);
        }
        return strategy;
    }

    static getAvailableStrategies(): { id: string; name: string }[] {
        const result: { id: string; name: string }[] = [];
        this.strategies.forEach((strategy, id) => {
            result.push({ id, name: strategy.name });
        });
        return result;
    }
}
